import _cloneDeep from 'lodash/cloneDeep';

export function cloneBlockPageInfo(blockPage) {
  return _cloneDeep(blockPage);
}
